import { USER_JWT_TOKEN_COOKIE_NAME } from "./constants";
import { useUserStore } from "~/stores/user";

/**
 * Middleware factory for registration pages: redirects logged-in non-customer
 * users (e.g. existing professionals) to `routeName`. Anonymous visitors and
 * logged-in customers stay — a customer registering as a professional must be
 * logged in as themself, so they have to be able to reach the form.
 */
export function redirectNonCustomersTo(routeName) {
  return async function redirectNonCustomers(context) {
    const { route, app, redirect, localePath } = context;
    const hasToken =
      app.$cookie.get(USER_JWT_TOKEN_COOKIE_NAME) || route.query.admin_token;

    if (!hasToken) {
      return;
    }

    const userStore = useUserStore(context.$pinia);

    if (!userStore.me) {
      try {
        await userStore.queryMe(true);
      } catch (error) {
        return;
      }
    }

    if (userStore.me && !userStore.me.isCustomer) {
      await redirect(localePath({ name: routeName }));
    }
  };
}

export const redirectIfNonCustomerMiddleware =
  redirectNonCustomersTo("indexPage");
